const WORK_GROUP_LIST = [
  {
    group: 'IPNET-FAULTS',
    section: 'IP Networks Operation',
  },
  {
    group: 'DS-MTCE',
    section: 'BB & Access',
  },
  {
    group: 'CEN-CEN-SW-SH',
    section: 'International & National Gateway Operation',
  },
  {
    group: 'INT-NW-SYSADMIN',
    section: 'ISP Operation',
  },
  {
    group: 'IPTV_MCR',
    section: 'IPTV Operation',
  },
  {
    group: 'INTL-TX-ITMC-CMB',
    section: 'International & National Transmission Operation',
  },
  {
    group: 'PBX-MTCE',
    section: 'PBX Section',
  },
  {
    group: 'CEN-ADSL-FAULTS',
    section: 'BB & Access',
  },
  {
    group: 'NOC-NETFM-LTE-ACC',
    section: 'Wireless Network Operation',
  },
  {
    group: 'CASC-MTCE',
    section: 'Cloud Application Support Team',
  },
  {
    group: 'TX-RADIO-LAB',
    section: 'International & National Transmission Operation',
  },
  {
    group: 'SFC-MGT-SFA',
    section: 'Service Fulfillment',
  },
  {
    group: 'NOC-NETFM-TX-LOCAL',
    section: 'International & National Transmission Operation',
  },
  {
    group: 'IDC-PROV',
    section: 'IDC Operation',
  },
  {
    group: 'CEN-CSC-PROV',
    section: 'CUSTOMER SERVICE CENTER -PROVISIONING',
  },
  {
    group: 'CASC-PROV',
    section: 'Cloud Application Support Team',
  },
  {
    group: 'NOC-NETFM-ACC-WIFI',
    section: 'ISP Operation Wi-Fi',
  },
  {
    group: 'NOC-NETFM-IPNET-CEA',
    section: 'IP Networks Operation (Internal links)',
  },
  {
    group: 'NOC-NETFM-IPNET-MPLS',
    section: 'IP Networks Operation (Internal links)',
  },
  {
    group: 'ASOP-SDWAN',
    section: 'APPLICATION SERVICES OPERATION-SDWAN',
  },
  {
    group: 'CEN-BB-TIER3',
    section: 'BB & Access',
  },
];

export default WORK_GROUP_LIST;
